import { render, staticRenderFns } from "./DialogCadastroProdutor.vue?vue&type=template&id=4a397988&scoped=true&"
import script from "./DialogCadastroProdutor.vue?vue&type=script&lang=js&"
export * from "./DialogCadastroProdutor.vue?vue&type=script&lang=js&"
import style0 from "./DialogCadastroProdutor.vue?vue&type=style&index=0&id=4a397988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a397988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VFlex,VForm,VLayout,VSpacer,VTextField})
